import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import { AdminAuthProvider } from "./context/AdminAuthContext";
import { DonorAuthProvider } from "./context/DonorAuthContext";
import { Toaster } from "sonner";

// Components
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";
import SeoManager from "./components/SeoManager";

// Pages
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ServicesPage from "./pages/ServicesPage";
import VolunteerPage from "./pages/VolunteerPage";
import PartnersPage from "./pages/PartnersPage";
import EventsPage from "./pages/EventsPage";
import ShopPage from "./pages/ShopPage";
import { AssistantWidget } from "./components/AssistantWidget";
import DonatePage from "./pages/DonatePage";
import ContactPage from "./pages/ContactPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminDashboardPage from "./pages/AdminDashboardPage";
import DonorLoginPage from "./pages/DonorLoginPage";
import DonorRegisterPage from "./pages/DonorRegisterPage";
import DonorDashboardPage from "./pages/DonorDashboardPage";
import WallOfHonorPage from "./pages/WallOfHonorPage";

// Toast configuration - defined outside component to avoid re-creation
const toastOptions = {
  style: {
    background: '#1A252C',
    color: '#fff',
    borderRadius: '12px',
  },
};

// Layout wrapper to conditionally show Navigation and Footer
const Layout = ({ children }) => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');
  const isDonorDashboard = location.pathname === '/donor/dashboard';

  return (
    <>
      <SeoManager />
      {!isAdminRoute && <Navigation />}
      <main className="flex-grow">
        {children}
      </main>
      {!isAdminRoute && !isDonorDashboard && <Footer />}
    </>
  );
};

function App() {
  return (
    <LanguageProvider>
      <AdminAuthProvider>
        <DonorAuthProvider>
          <div className="App min-h-screen flex flex-col">
            <BrowserRouter>
              <Layout>
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/about" element={<AboutPage />} />
                  <Route path="/services" element={<ServicesPage />} />
                  <Route path="/volunteer" element={<VolunteerPage />} />
                  <Route path="/partners" element={<PartnersPage />} />
                  <Route path="/events" element={<EventsPage />} />
                  <Route path="/shop" element={<ShopPage />} />
                  <Route path="/donate" element={<DonatePage />} />
                  <Route path="/contact" element={<ContactPage />} />
                  <Route path="/wall-of-honor" element={<WallOfHonorPage />} />
                  <Route path="/admin" element={<AdminLoginPage />} />
                  <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
                  <Route path="/donor/login" element={<DonorLoginPage />} />
                  <Route path="/donor/register" element={<DonorRegisterPage />} />
                  <Route path="/donor/dashboard" element={<DonorDashboardPage />} />
                </Routes>
                <AssistantWidget />
              </Layout>
            </BrowserRouter>
            <Toaster 
              position="top-right"
              toastOptions={toastOptions}
            />
          </div>
        </DonorAuthProvider>
      </AdminAuthProvider>
    </LanguageProvider>
  );
}

export default App;
